module.exports = __webpack_public_path__ + "footer-icon-instagram.119b5182a9f23b02766a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/share/footer-icon-instagram.svg
// module id = 1015
// module chunks = 2